import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Client } from './client';
import { catchError, map } from 'rxjs/operators';


@Injectable()
export class VehicleManageService {

  constructor ( private http: HttpClient, private client: Client ) {
  }

  LogistGetVehicles ( service_id ): Observable<any> {

    return this.http.get( this.client.getLogistVehiclesUrl( { 'service': service_id } ) ).pipe(
      map( res => {
        return res['data'];
      } ),
      catchError( ( error: any ) => Observable.throw( error.code || error.error || 'UNDEF error' ) )
    );
  }

  getAllBudjetVehicle ( service_id ): Observable<any> {

    return this.http.get( this.client.getAllBudgetVehiclesUrl( { 'service': service_id } ) ).pipe(
      map( res => {
        return res['data'];
      } ),
      catchError( ( error: any ) => Observable.throw( error.code || error.error || 'UNDEF error' ) )
    );
  }

  LogistGetAllCabs ( service_id ): Observable<any> {

    return this.http.get( this.client.getAllLogistCabsUrl( { 'service': service_id } ) ).pipe(
      map( res => {
        console.log( '-cabs-' );
        console.log( res );
        return res;
      } ),
      catchError( ( error: any ) => Observable.throw( error.code || error.error || 'UNDEF error' ) )
    );
  }

  LogistRemoveCar ( service_id, vehicle_id ): Observable<any> {

    return this.http.delete( this.client.getLogistManipulationVehicleUrl(), {
      params: { 'vehicle': vehicle_id, 'service': service_id },
    } ).pipe(
      map( res => {
        return res;
      } ),
      catchError( ( error: any ) => Observable.throw( error.code || error.error || 'UNDEF error' ) )
    );
  }

  LogistAddCar ( service_id, vehicle_id ): Observable<any> {
    return this.http.post(
      this.client.getLogistManipulationVehicleUrl(),
      { 'vehicle': vehicle_id, 'service': service_id }
    ).pipe(
      map( res => {
        console.log( res );
        return res;
      } ),
      catchError( ( error: any ) => Observable.throw( error.code || error.error || 'UNDEF error' ) )
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/vihicle-manage.service.ts